/**
 * Team launcher. Opens the last agent seat as a real route.
 * The thread lives in the shell, not in a modal over the current page.
 */

import { useLocation, useNavigate } from 'react-router-dom'
import { MessageSquare } from 'lucide-react'
import { isAgentShellPath, lastSeat, seatPath } from '@/lib/agent-seats'

export default function ChatLauncher() {
  const navigate = useNavigate()
  const location = useLocation()
  if (isAgentShellPath(location.pathname) || location.pathname.startsWith('/chat')) return null

  return (
    <button
      type="button"
      onClick={() => navigate(seatPath(lastSeat()))}
      className="fixed bottom-4 right-4 z-40 flex h-12 w-12 items-center justify-center rounded-full shadow-lg transition-all hover:scale-105 active:scale-95 md:bottom-6 md:right-6"
      style={{ background: 'var(--brand-500)', color: 'var(--text-inverse)' }}
      aria-label="Open your team"
    >
      <MessageSquare className="h-5 w-5" />
    </button>
  )
}
